import { SVGProps } from 'react';

interface IProps {
  placement?: 'top' | 'bottom' | 'left' | 'right';
  pathProps?: SVGProps<SVGPathElement>;
}

const ArrowDawnIcon = ({ placement = 'bottom', pathProps }: IProps) => {
  const obj = {
    top: '180deg',
    bottom: '0deg',
    left: '90deg',
    right: '-90deg'
  };

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${obj[placement]})` }}
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </svg>
  );
};

export default ArrowDawnIcon;
